import { render, staticRenderFns } from "./Tutorial.vue?vue&type=template&id=04638d4b&"
import script from "./Tutorial.vue?vue&type=script&lang=ts&"
export * from "./Tutorial.vue?vue&type=script&lang=ts&"
import style0 from "./Tutorial.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports